import React from 'react';
import { Rect } from 'react-konva';
import withMouseEvent from '../../hoc/withMouseEvent';

const Rectangle = React.forwardRef(({ attrs }, ref) => {
  return (<Rect {...attrs} ref={ref} />);
});

export default withMouseEvent(Rectangle);